import type { RootState } from 'src/redux/store'
import { createSelector } from 'reselect'
import { getFullProductDetails } from 'src/utils/product'

type PlainInfo<T> = {
  status: RequestState
  error?: string
  data: T
}

type RequestState = 'pending' | 'fulfilled' | 'rejected' | 'none'

interface OrderState {
  storeOrder: PlainInfo<Oms.V4.StoreOrder>
  eligiblePromotions: PlainInfo<{
    promotions: SelectedPromotion[]
    promoCodePromotions: SelectedPromotion[]
    promoCodeEnabled: boolean
    ok: boolean
  }>
  selectedPromotions: PlainInfo<SelectedPromotion[]>
  availableTimeSlots: PlainInfo<
    {
      id: string
      name: string
      description: string
      stackableOption: number
      isPromoCodePromotion: boolean
      x: string
      y: string
    }[]
  >
}

export const selectOrder = (state: RootState): OrderState => state['@order']

const selectFromStoreOrder = (state) =>
  state['@order'].storeOrder.data.orderItems

export const createOrderItemsSelector = (selector = selectFromStoreOrder) =>
  createSelector(
    [selector, (state) => state['@menu'].data],
    (orderItems, menu) =>
      (orderItems || [])
        .filter((item) => !item.isPromotionalItem && item.quantity > 0)
        .map((item) => getFullProductDetails(menu || [], item))
  )

export const createPromotionalOrderItemsSelector = (
  selector = selectFromStoreOrder
) =>
  createSelector(
    [selector, (state) => state['@menu'].data],
    (orderItems, menu) =>
      (orderItems || [])
        .filter((item) => item.isPromotionalItem)
        .map((item) => getFullProductDetails(menu || [], item))
  )

export const checkAppointmentReady = (state: RootState): boolean => {
  const {
    isPickup,
    storeAddress,
    deliveryAddress,
    defaultStoreId
  } = state['@order'].storeOrder.data

  return (isPickup && !!storeAddress && !defaultStoreId) || (!isPickup && !!deliveryAddress)
}
